module.exports = __webpack_public_path__ + "static/img/img-dg.9c4b63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/img-dg.png
// module id = +EzA
// module chunks = 0